import { Fragment as e, computed as t, createBlock as n, createCommentVNode as r, createElementBlock as i, createElementVNode as a, createSlots as o, createTextVNode as s, createVNode as c, defineComponent as l, inject as u, isRef as d, markRaw as f, mergeProps as p, nextTick as m, normalizeClass as h, normalizeStyle as g, onBeforeMount as _, onBeforeUnmount as v, onMounted as y, onUnmounted as b, openBlock as x, provide as S, ref as C, renderList as w, renderSlot as T, resolveDynamicComponent as E, toDisplayString as D, toRaw as O, toRef as k, unref as A, useSlots as j, useTemplateRef as ee, vShow as M, watch as N, withCtx as P, withDirectives as F } from "vue";
import { BBadge as I, BButton as L, BButtonGroup as te, BCard as R, BFormCheckbox as z, BFormCheckboxGroup as ne, BFormFile as re, BFormGroup as ie, BFormInput as ae, BFormRadioGroup as oe, BFormSelect as se, BFormTags as ce, BFormTextarea as le, BInputGroup as ue, BInputGroupText as de, BModal as fe, BPopover as pe, BSpinner as me } from "bootstrap-vue-next";
import { createPinia as he, defineStore as ge, getActivePinia as _e, setActivePinia as ve, storeToRefs as B } from "pinia";
import { v4 as ye } from "uuid";
import be from "json-pointer";
import { EmptyValidator as xe, keywords as Se } from "@educorvi/vue-json-form-schemas";
import Ce from "deepmerge";
import we from "fast-deep-equal";
import { Atom as Te, HasNoLengthError as Ee, Parser as De, RitaError as Oe, UndefinedPathError as ke, getAtoms as Ae } from "@educorvi/rita";
import je from "sanitize-html";
import { watchDebounced as Me } from "@vueuse/core";
import Ne from "vuedraggable/src/vuedraggable";
import "vue-component-type-helpers";
//#region \0rolldown/runtime.js
var Pe = Object.defineProperty, V = (e, t) => {
	let n = {};
	for (var r in e) Pe(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Pe(n, Symbol.toStringTag, { value: "Module" }), n;
}, Fe = /* @__PURE__ */ l({
	__name: "ArrayButton",
	props: {
		disabled: { type: Boolean },
		ariaLabel: {},
		variant: {}
	},
	emits: ["click"],
	setup(e, { emit: t }) {
		let r = e, i = t;
		return (e, t) => (x(), n(A(L), {
			variant: r.variant,
			disabled: r.disabled,
			"aria-label": r.ariaLabel,
			onClick: t[0] ||= (e) => i("click")
		}, {
			default: P(() => [T(e.$slots, "default")]),
			_: 3
		}, 8, [
			"variant",
			"disabled",
			"aria-label"
		]));
	}
}), Ie = {
	key: 0,
	class: "vjf_showOnWrapper"
}, Le = /* @__PURE__ */ l({
	__name: "showOnWrapper",
	props: { visible: { type: Boolean } },
	setup(e) {
		return (t, n) => e.visible ? (x(), i("div", Ie, [T(t.$slots, "default")])) : r("", !0);
	}
}), Re = { class: "wrappers-parent" }, ze = { class: "stepWrapper" }, Be = { class: "d-flex justify-content-between" }, Ve = ["disabled", "onClick"], He = { class: "stepWrapperBg" }, Ue = { class: "d-flex justify-content-between" }, We = /* @__PURE__ */ l({
	__name: "WizardProgress",
	props: {
		numberOfPages: {},
		pageNames: {},
		currentStep: {}
	},
	emits: ["update:currentStep"],
	setup(t, { emit: n }) {
		let r = t, o = n;
		function s(e) {
			let t = e - 1;
			t < r.currentStep && o("update:currentStep", t);
		}
		return N(() => r.currentStep, () => {
			document.querySelectorAll(".wrappers-parent").forEach((e) => {
				let t = e.querySelector(".custom-wizard-progress"), n = e.querySelectorAll(".stepWrapper .stepNumber");
				if (!t || n.length < 2) return;
				let i = n[0], a = n[n.length - 1];
				if (!i || !a) return;
				let o = i.offsetLeft + i.offsetWidth / 2, s = a.offsetLeft + a.offsetWidth / 2 - o, c = (o + r.currentStep / (n.length - 1) * s) / t.offsetWidth * 100;
				t.style.setProperty("--progress", `${c}%`);
			});
		}, { immediate: !0 }), (n, o) => (x(), i("div", Re, [
			a("div", ze, [a("div", Be, [(x(!0), i(e, null, w(Array.from({ length: r.numberOfPages }, (e, t) => t + 1), (e) => (x(), i("div", {
				key: "wizard-fg-" + e,
				class: h({
					"stepNumber d-flex justify-content-center align-items-center": !0,
					active: e - 1 === t.currentStep,
					filled: e - 1 < t.currentStep
				})
			}, [a("button", {
				disabled: e > t.currentStep,
				class: "fs-4",
				onClick: () => s(e)
			}, D(e), 9, Ve)], 2))), 128))])]),
			o[0] ||= a("div", { class: "custom-wizard-progress" }, null, -1),
			a("div", He, [a("div", Ue, [(x(!0), i(e, null, w(Array.from({ length: r.numberOfPages }, (e, t) => t + 1), (e) => (x(), i("div", {
				key: "wizard-bg-" + e,
				class: h({
					"stepNumber d-flex justify-content-center align-items-center": !0,
					active: e - 1 === t.currentStep,
					filled: e - 1 < t.currentStep
				})
			}, null, 2))), 128))])])
		]));
	}
}), H = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, Ge = /* @__PURE__ */ H(We, [["__scopeId", "data-v-04553480"]]), Ke = /* @__PURE__ */ V({
	descendantControlOverridesProviderKey: () => Qe,
	formIdProviderKey: () => qe,
	formStructureProviderKey: () => Je,
	inArrayItemProviderKey: () => et,
	languageProviderKey: () => $e,
	mergeDescendantControlOptionsOverrides: () => rt,
	requiredProviderKey: () => Ye,
	savePathOverrideProviderKey: () => Xe,
	savePathProviderKey: () => Ze,
	setDescendantControlOverride: () => nt,
	setDescendantControlOverrides: () => tt
}), qe = Symbol(), Je = Symbol(), Ye = Symbol(), Xe = Symbol(), Ze = Symbol(), Qe = Symbol(), $e = Symbol(), et = Symbol();
function tt(e) {
	if (e) for (let [t, n] of Object.entries(e)) nt(t, n);
}
function nt(e, t) {
	let n = u(Qe);
	n ||= {};
	let r = n[e];
	r ? n[e] = {
		showOn: t.showOn || r.showOn,
		options: {
			...r.options,
			...t.options
		}
	} : n[e] = t, S(Qe, n);
}
function rt(e, t) {
	if (!t) return e;
	let n = t[Y(e.scope)];
	return n ? {
		...e,
		options: {
			...e.options,
			...n.options
		},
		showOn: n.showOn || e.showOn
	} : e;
}
//#endregion
//#region src/Commons.ts
var it = "vjf_array-item_", at = "2.2";
function ot(e) {
	if (e.version?.split?.(".")?.length !== 2) return !1;
	let [t, n] = e.version.split(".").map(Number), [r, i] = "2.2".split(".").map(Number);
	return !(t !== r || (n ?? 2 ** 53 - 1) > (i ?? 0));
}
function st() {
	let e;
	try {
		e = crypto.randomUUID();
	} catch {
		e = ye();
	}
	return e;
}
function ct(e) {
	return typeof e == "string" ? e.match(RegExp(`^${it}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$`)) !== null : !1;
}
function lt(e, t) {
	return `${e}.${t}`;
}
function U(e, t) {
	return e.split("/").slice(0, t).join("/");
}
function ut(e) {
	return e?.split("/").pop();
}
function dt(e) {
	return e.map((e) => ({
		...e,
		uuid: st()
	}));
}
function ft(e, t = {}) {
	let n = {
		version: "2.2",
		layout: {
			type: t.layoutType ?? "VerticalLayout",
			options: {
				label: "groupLabel" in t ? t.groupLabel : void 0,
				description: "groupDescription" in t ? t.groupDescription : void 0
			},
			elements: []
		}
	};
	for (let r in e.properties) {
		let e = {
			type: "Control",
			scope: `${t.scopeBase ?? ""}/properties/${r}`
		};
		n.layout.elements.push(e);
	}
	return n;
}
function pt(e, t, n = ".", r) {
	t = t.replace(/\[(\w+)]/g, `${n}$1`), t = t.replace(RegExp(`^${((e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))(n)}`), "");
	let i = t.split(n);
	for (let n = 0, a = i.length; n < a; ++n) {
		let a = i[n];
		if (a === void 0) return r;
		if (typeof e != "object") {
			if (r !== void 0) return r;
			throw Error("Invalid path in data: " + t + " is of invalid type " + typeof e + " with value " + e);
		}
		if (a in e) e = e[a];
		else if (r !== void 0) return r;
		else throw Error("Undefined path in data: " + t);
	}
	return e;
}
//#endregion
//#region src/stores/helpers/flattenData.ts
function mt(e, t, n) {
	let r = e.map((e) => ({
		item: e,
		id: it + st()
	}));
	t[n] = r.map((e) => e.id), r.forEach((e) => {
		if (e.item !== null && typeof e.item == "object" && !(e.item instanceof Date) && !(typeof File < "u" && e.item instanceof File)) {
			let r = "";
			Array.isArray(e.item) || (r = "/properties"), ht(e.item, t, `${n}.${e.id}${r}`);
		} else t[`${n}.${e.id}`] = e.item;
	});
}
function ht(e, t = {}, n = "/properties") {
	if (Array.isArray(e)) mt(e, t, n);
	else for (let [r, i] of Object.entries(e)) {
		let e = `${n}/${r}`;
		Array.isArray(i) ? mt(i, t, e) : typeof i == "object" && i ? ht(i, t, `${e}/properties`) : t[e] = i;
	}
	return t;
}
//#endregion
//#region src/renderings/default/DefaultComponents.ts
var gt = { ConfirmationModal: /* @__PURE__ */ l({
	__name: "ConfirmationModal",
	props: {
		title: {},
		confirmButtonText: {},
		cancelButtonText: {},
		hideCancelButton: { type: Boolean },
		confirmButtonVariant: {},
		cancelButtonVariant: {}
	},
	emits: ["confirm", "cancel"],
	setup(e, { expose: t, emit: n }) {
		let r = n, i = j();
		return t({ show: () => {
			confirm(i.default({})[0]?.children) ? r("confirm") : r("cancel");
		} }), () => {};
	}
}) };
//#endregion
//#region src/stores/formStructure.ts
function _t(e, t = "/properties/") {
	let n = {};
	for (let [r, i] of Object.entries(e.properties || {})) if (typeof i == "boolean") continue;
	else if (i.type === "object") n = {
		...n,
		..._t(i, t + r + "/properties/")
	};
	else if (i.default !== void 0) {
		let e = i.default;
		e === "$now" && (e = (/* @__PURE__ */ new Date()).toISOString()), n[t + r] = e;
	}
	return n;
}
function vt(e) {
	return ge("structure-" + e, {
		state: () => ({
			jsonSchema: void 0,
			uiSchema: void 0,
			components: void 0,
			mappers: [],
			buttonWaiting: {},
			currentWizardPage: 0,
			wizardValidateFunctions: [],
			formStateWasValidated: !1
		}),
		getters: { defaultData: (e) => {
			if (!e.jsonSchema) return {};
			let t = _t(e.jsonSchema);
			return Object.entries(t).forEach(([e, n]) => {
				Array.isArray(n) && mt(n, t, e);
			}), t;
		} },
		actions: { getComponent(e) {
			let t = this.components;
			if (!t) throw Error("Components not initialized yet");
			let n = t[e];
			if (n ||= gt[e], !n) throw Error(`Component ${e} not found`);
			return n;
		} }
	});
}
var yt = /* @__PURE__ */ new Map();
function bt(e) {
	return yt.has(e) || yt.set(e, vt(e)), yt.get(e)();
}
//#endregion
//#region src/Mappers/MapperClass.ts
var xt = class {
	clone(e) {
		return JSON.parse(JSON.stringify(e));
	}
	cloneUiElement(e) {
		return this.clone(e);
	}
	cloneJsonElement(e) {
		return this.clone(e);
	}
	cloneElements(e, t) {
		return {
			newJsonElement: this.cloneJsonElement(e),
			newUiElement: this.cloneUiElement(t)
		};
	}
}, St = class extends xt {}, Ct = class extends xt {
	jsonSchema;
	uiSchema;
	savePath;
	scope;
	jsonElement;
	uiElement;
	formId;
	registerSchemata(e, t, n, r, i, a, o = "default") {
		this.jsonSchema = e, this.uiSchema = t, this.scope = n, this.savePath = r, this.jsonElement = i, this.uiElement = a, this.formId = o;
	}
};
//#endregion
//#region src/Mappers/oneOfToEnumMapper.ts
function wt(e) {
	return typeof e == "object" && e.const !== void 0 && e.title !== void 0;
}
var Tt = class extends St {
	map(e, t) {
		if (K(e, "oneOf")) {
			let n, r = {};
			for (let t of e.oneOf) {
				if (!wt(t)) return console.warn("oneOf element is not a custom oneOf element"), null;
				n ? n.push(t.const) : n = [t.const], r[t.const] = t.title;
			}
			if ((n?.length || 0) < 1) return console.warn("No values found in oneOf element"), null;
			{
				let { newJsonElement: i, newUiElement: a } = this.cloneElements(e, t);
				return i.enum = n, delete i.oneOf, a.options = { enumTitles: r }, {
					jsonElement: i,
					uiElement: a
				};
			}
		}
		return {
			jsonElement: e,
			uiElement: t
		};
	}
}, W = /* @__PURE__ */ function(e) {
	return e.CONST = "const", e.ENUM = "enum", e.CONTAINS_CONST = "containsConst", e.CONTAINS_ENUM = "containsEnum", e.MIN_LENGTH = "minLength", e.REQUIRED = "required", e;
}(W || {}), Et = class extends Ct {
	conditionsAndResults = [];
	dependencies = [];
	registerSchemata(e, t, n, r, i, a) {
		super.registerSchemata(e, t, n, r, i, a), this.conditionsAndResults = this.getConditionsAndResults(), this.setDependencies();
	}
	setDependencies() {
		let e = /* @__PURE__ */ new Set();
		for (let t of this.conditionsAndResults) for (let n of t.conditions) e.add(n.savePath);
		this.dependencies = Array.from(e);
	}
	getDependencies() {
		return this.dependencies;
	}
	getFieldName() {
		return ut(this.scope);
	}
	parseCondition([e, t]) {
		let n, r;
		if ("const" in t) n = W.CONST, r = t.const;
		else if ("enum" in t) n = W.ENUM, r = t.enum;
		else if ("contains" in t) if ("const" in t.contains) n = W.CONTAINS_CONST, r = t.contains.const;
		else if ("enum" in t.contains) n = W.CONTAINS_ENUM, r = t.contains.enum;
		else throw Error("Invalid contains condition");
		else if ("minLength" in t) n = W.MIN_LENGTH, r = t.minLength;
		else throw Error("Invalid condition");
		let i = this.scopeToSavePath(e);
		return {
			value: r,
			type: n,
			key: e,
			savePath: i
		};
	}
	scopeToSavePath(e) {
		let t = e, n = this.savePath?.split("/");
		for (let e = n?.length ?? 0; e >= 0; --e) {
			let r = n?.slice(0, e).join("/");
			if (!r) break;
			if (t.includes(Y(r))) {
				t = t.replace(Y(r), r);
				break;
			}
		}
		return t;
	}
	addRequiredConditions(e, t, n) {
		let r = [], i = "required" in e && e.required || [];
		for (let e of i) {
			let i = n + "/properties/" + e, a = this.scopeToSavePath(i);
			t.some((e) => e.savePath === a) || r.push({
				key: e,
				savePath: a,
				value: null,
				type: W.REQUIRED
			});
		}
		return r;
	}
	parseConditions(e, t) {
		let n = [];
		if ("properties" in e) {
			let r = t + "/properties", i = e.properties;
			for (let [e, t] of Object.entries(i || {})) {
				let i = r + "/" + e;
				Jt(t) ? n.push(this.parseCondition([i, t])) : n = n.concat(this.parseConditions(t, i));
			}
		} else if ("items" in e) {
			let r = t + "/items";
			Jt(e.items) ? n.push(this.parseCondition([r, e.items])) : Zt(e.items) && (n = n.concat(this.parseConditions(e.items, r)));
		}
		return n = n.concat(this.addRequiredConditions(e, n, t)), n;
	}
	getConditionsAndResultsFromAllOf(e, t) {
		if (!this.jsonSchema) return [];
		let n;
		if (be.has(this.jsonSchema, e)) n = be.get(this.jsonSchema, e);
		else return [];
		if (!n || !Array.isArray(n)) return [];
		let r = n.filter($t);
		r.length > 0 && r.length !== n.length && console.warn(`Unsupported if/then/else structure(s) found in ${e}`, n.filter((e) => !$t(e)));
		let i = t.replace(U(e, -1) + "/", "");
		return r.map((t) => {
			let n = pt(t.then, i, "/", null), r = pt(t.else, i, "/", null), a = U(i, -2), o = pt(t.then, a + "/required", "/", null), s = pt(t.else, a + "/required", "/", null);
			if (!(!n && !r && !o && !s)) return {
				conditions: this.parseConditions(t.if, U(e, -1)),
				then: n,
				else: r,
				thenRequired: o,
				elseRequired: s
			};
		}).filter((e) => e !== void 0);
	}
	getConditionsAndResults() {
		let e = [];
		if (!this.scope || !this.jsonSchema || !this.uiSchema) return e;
		for (let t = -2; this.scope.split("/").length + t >= 0; t -= 2) {
			let n = U(this.scope, t).replace(/\/properties$/, "") + "/allOf";
			n = Y(n), e = e.concat(this.getConditionsAndResultsFromAllOf(n, this.scope));
		}
		return e;
	}
	checkRequiredConditionFulfilled(e, t, n) {
		return nn(e) && e !== "" ? !0 : Object.keys(t).filter((e) => e.startsWith(n + "/")).some((e) => nn(t[e]) && t[e] !== "");
	}
	checkConditionFulfilled(e, t) {
		if (!this.savePath || !this.scope) return !1;
		let n = t[e.savePath];
		switch (e.type) {
			case W.CONST: return we(n, e.value);
			case W.ENUM: return e.value.includes(n);
			case W.CONTAINS_CONST: return Array.isArray(n) ? n.includes(e.value) : !1;
			case W.CONTAINS_ENUM: return Array.isArray(n) ? n.some((t) => e.value.includes(t)) : !1;
			case W.MIN_LENGTH: return (n?.length ?? 0) >= e.value;
			case W.REQUIRED: return this.checkRequiredConditionFulfilled(n, t, e.savePath);
		}
	}
	async map(e, t, n) {
		let r = this.getFieldName();
		if (!this.jsonSchema || !this.uiSchema || !this.savePath || !r) return {
			jsonElement: e,
			uiElement: t
		};
		let { newJsonElement: i, newUiElement: a } = this.cloneElements(e, t), o = !1, s = !1;
		for (let e of this.conditionsAndResults) {
			let { then: t, else: c, elseRequired: l, thenRequired: u } = e;
			if (!t && !c && !u && !l) continue;
			let d = e.conditions.every((e) => this.checkConditionFulfilled(e, n)), f = d ? t || {} : c || {};
			for (let [e, t] of Object.entries(f)) if (Bt(e)) {
				if (typeof t != "object") i[e] !== t && (i[e] = t, o = !0);
				else if (t) {
					let n = Ce(i[e] || {}, t, { arrayMerge: (e, t, n) => t });
					JSON.stringify(n) !== JSON.stringify(i[e] || {}) && (i[e] = n, o = !0);
				}
			}
			(d ? u : l)?.includes(r) && (a.options ||= {}, a.options.forceRequired = !0, s = !0);
		}
		return {
			jsonElement: o ? i : e,
			uiElement: s ? a : t
		};
	}
};
//#endregion
//#region src/renderings/renderHelpers/utilities.ts
function G(e, t, n) {
	if (q(e, t)) {
		let n = e.options[t];
		if (n !== void 0) return n;
	}
	return n;
}
//#endregion
//#region src/components/ShowOnLogic.ts
function Dt(e) {
	switch (e) {
		case "EQUALS": return (e, t) => e == t;
		case "NOT_EQUALS": return (e, t) => e != t;
		case "GREATER": return (e, t) => e > t;
		case "GREATER_OR_EQUAL": return (e, t) => e >= t;
		case "SMALLER": return (e, t) => e < t;
		case "SMALLER_OR_EQUAL": return (e, t) => e < t;
	}
}
var Ot = RegExp(`^([^.\\s]+)\\.(${it}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})`);
function kt(e, t) {
	let { formDataStore: n } = X(t), r = {};
	if (e.type === "Control") {
		let t = e.scope.split("/");
		t.map((e, n) => {
			let r = e.match(Ot);
			return r ? {
				arrayName: t.slice(0, n).join("/") + "/" + r[1],
				arrayAlias: r[2]
			} : null;
		}).forEach((e) => {
			if (e) {
				let t = Y(e.arrayName);
				r[t] = n.arrayAliasIndices.get(e.arrayAlias || "") ?? 0;
			}
		});
	}
	return r;
}
function At(e, n) {
	let { formDataStore: r } = X(n);
	if (zt(e.showOn)) return t(() => {
		if (!zt(e.showOn)) throw Error("This should not happen");
		let t = Dt(e.showOn.type), n = e.showOn.referenceValue;
		try {
			return t(Te.getPropertyByString(r.cleanedFormData.json, e.showOn.path, ""), n);
		} catch (t) {
			return t instanceof ke && console.warn(`Error while evaluating showOn rule: ${t.message}`, e.showOn), !1;
		}
	});
	{
		let t = C(!1), i = new De(), a;
		try {
			a = i.parseRule(e.showOn);
		} catch (n) {
			return console.warn(`Error while parsing showOn rule '${e.showOn?.id}'`, n), t;
		}
		return r.$subscribe(() => {
			let i = {
				$selfIndices: kt(e, n),
				...r.cleanedFormData.json
			};
			a.evaluate(i).then((e) => {
				t.value = e;
			}).catch((e) => {
				t.value = !1, e instanceof Ee ? console.warn(`Error while evaluating showOn rule "${a.id}": ${e.message}\nIn formula:`, e.context, "with value", e.value) : e instanceof Oe ? console.warn(`Error while evaluating showOn rule "${a.id}": ${e.message}\nIn formula:`, e.context) : console.warn(`Error while evaluating showOn rule "${a.id}": ${e.message}`);
			});
		}), t;
	}
}
function jt(e, t, n) {
	let r = e;
	return e.type === "Control" && (r = rt(e, t)), Ft(r) ? At(r, n) : C(!0);
}
//#endregion
//#region src/Mappers/ritaDependentOptionsMapper.ts
var Mt = class e extends Ct {
	depsRuleMap = {};
	dependencies = [];
	static parser = new De();
	getDependencies() {
		return this.dependencies;
	}
	async map(e, t, n, r) {
		if (Object.keys(this.depsRuleMap).length === 0) return {
			jsonElement: e,
			uiElement: t
		};
		let i = this.cloneJsonElement(e), a = {
			$selfIndices: kt(t, this.formId),
			...r
		}, o = !1, s = [];
		for (let [e, t] of Object.entries(this.depsRuleMap)) s.push([e, await t.evaluate(a)]);
		let c = s.filter(([e, t]) => !t).map(([e, t]) => e);
		return c.length > 0 && (i.enum = i.enum?.filter((e) => !c.includes(e)), o = !0), {
			jsonElement: o ? i : e,
			uiElement: t
		};
	}
	registerSchemata(e, t, n, r, i, a, o) {
		super.registerSchemata(e, t, n, r, i, a, o);
		let s = /* @__PURE__ */ new Set();
		this.depsRuleMap = this.getOptionFilterDependencies(a, s, r), this.dependencies = Array.from(s);
	}
	getOptionFilterDependencies(t, n, r) {
		let i = {}, a = G(t, "optionFilters");
		if (a) for (let [t, r] of Object.entries(a)) try {
			let a = e.parser.parseRule(r);
			i[t] = a;
			let o = Ae([a]);
			for (let e of o.pathSet) {
				let t = "/properties/" + e.split("[")[0]?.split(".").join("/properties/");
				n.add(t);
			}
		} catch {
			console.warn(`Invalid rule ${r.id} for option ${t}`);
		}
		return i;
	}
}, Nt = class extends Ct {
	dependencies = [];
	getDependencies() {
		return this.dependencies;
	}
	registerSchemata(e, t, n, r, i, a) {
		super.registerSchemata(e, t, n, r, i, a);
		let o = gn(e, U(n, -2) + "/dependentRequired");
		if (!o) return;
		let s = Object.entries(o).map(([e, t]) => ({
			key: e,
			requiresThis: t.includes(n.split("/").pop() || "")
		})).filter(({ requiresThis: e }) => e).map(({ key: e }) => e);
		this.dependencies = s.map((e) => U(r, -1) + "/" + e);
	}
	async map(e, t, n) {
		let r = !1;
		for (let e of this.dependencies) if (n[e]) {
			r = !0;
			break;
		}
		if (r) {
			let n = this.cloneUiElement(t);
			return n.options ||= {}, n.options.forceRequired = !0, {
				jsonElement: e,
				uiElement: n
			};
		} else return {
			jsonElement: e,
			uiElement: t
		};
	}
};
//#endregion
//#region src/typings/typeValidators.ts
function Pt(e, t) {
	return e in t;
}
function K(e, t) {
	return !(typeof e == "object" && e && e !== void 0) || !Pt(t, e) ? !1 : e[t] !== void 0 && e[t] !== null;
}
function Ft(e) {
	return K(e, "showOn");
}
function It(e) {
	return Array.isArray(e.elements);
}
function Lt(e) {
	return e ? "displayAs" in e && e?.displayAs === "buttons" : !1;
}
function Rt(e) {
	return K(e, "options") && K(e.options, "cssClass");
}
function zt(e) {
	return e && "path" in e && "type" in e && "referenceValue" in e;
}
function Bt(e) {
	return Se.find((t) => t === e) !== void 0;
}
function q(e, t) {
	return K(e, "options") && K(e.options, t);
}
function Vt(e) {
	return K(e, "items") && typeof e.items == "object" && !Array.isArray(e.items);
}
function Ht(e) {
	return K(e, "items") && K(e.items, "enum");
}
function Ut(e) {
	return [
		"text",
		"time",
		"date",
		"datetime-local",
		"email",
		"password",
		"search",
		"url",
		"tel",
		"color",
		"hidden"
	].includes(e);
}
function Wt(e) {
	return Ut(e) && e !== "hidden";
}
function Gt(e) {
	return e instanceof St;
}
function Kt(e) {
	return e instanceof Ct;
}
function qt(e) {
	return Array.isArray(e) && e.every($t);
}
function Jt(e) {
	return K(e, "const") || K(e, "enum") || K(e, "minLength") || K(e, "contains") && (K(e.contains, "const") || K(e.contains, "enum"));
}
function Yt(e) {
	return K(e, "properties") && Object.values(e.properties).every((e) => typeof e == "object" && !!e && Xt(e)) || K(e, "items") && Xt(e.items) || K(e, "required") && nn(e.required);
}
function Xt(e) {
	return Jt(e) || Yt(e);
}
function Zt(e) {
	return Yt(e);
}
function Qt(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function $t(e) {
	return K(e, "if") && Zt(e.if) && "then" in e && Qt(e.then) && ("else" in e ? Qt(e.else) : !0);
}
function en(e) {
	return e !== void 0;
}
function tn(e) {
	return e.every(en);
}
function nn(e) {
	return e != null;
}
function rn(e) {
	return e.type === "Wizard";
}
function an(e) {
	return !rn(e);
}
function on(e) {
	return e ? "checkValidity" in e && typeof e.checkValidity == "function" && "reportValidity" in e && typeof e.reportValidity == "function" : !1;
}
function sn(e) {
	return on(e) && "setCustomValidity" in e && typeof e.setCustomValidity == "function";
}
//#endregion
//#region src/stores/helpers/setPropertyByScope.ts
function cn(e, t, n) {
	let r = "!#index#!", i = RegExp(`${r}\\w+${r}`);
	if (n === void 0) return;
	let a = t.split("/").filter((e) => e !== "").filter((e, t) => !(t % 2 == 0 && e === "properties")).join(".").replace(/\[(\w+)]/g, `.${r}$1${r}`).split(".");
	for (let t = 0; t < a.length; t++) {
		let o = a[t];
		o && (i.test(o) && (o = parseInt(o.replace(r, ""))), t === a.length - 1 ? e[o] = e[o] || n : (i.test(a[t + 1] ?? "") ? e[o] = e[o] || [] : e[o] = e[o] || {}, e = e[o]));
	}
}
//#endregion
//#region src/stores/helpers/array.ts
function ln(e, t) {
	let n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set();
	for (let [i, a] of Object.entries(e)) xn(i, t) && (r.add(i), Array.isArray(a) && a.forEach((e, t) => {
		ct(e) && n.set(e, t);
	}));
	return {
		arrayIndices: n,
		arrays: r
	};
}
//#endregion
//#region src/stores/helpers/cleanData.ts
function un(e) {
	let t = {};
	for (let [n, r] of Object.entries(e)) cn(t, n, r);
	return t;
}
function dn(e, t) {
	for (let [n, r] of e.entries()) t = t.replace(`.${n}`, `[${r}]`);
	return t;
}
function fn(e, t, n) {
	let r = {}, { arrayIndices: i, arrays: a } = ln(e, n);
	for (let t of a) {
		let n = e[t];
		Array.isArray(n) && !n.filter((e) => ct(e)).length && n.length > 0 && (r[dn(i, t)] = [...n]);
	}
	for (let [t, a] of Object.entries(e)) !xn(t, n) && a !== void 0 && (r[dn(i, t)] = a);
	for (let n of Object.values(t)) {
		let t = e[n.key];
		t && Array.isArray(t) && t.length === 0 && (n.jsonSchema.minItems || 0) > 0 && !n.required && delete r[dn(i, n.key)];
	}
	return {
		scopes: r,
		json: un(r)
	};
}
//#endregion
//#region src/stores/formData.ts
function pn(e) {
	return ge("data-" + e, {
		state: () => ({
			formData: {},
			defaultFormData: {},
			arrays: {}
		}),
		getters: {
			arrayAliasIndices: (t) => ln(t.formData, e).arrayIndices,
			cleanedFormData: (t) => fn(t.formData, t.arrays, e)
		}
	});
}
var mn = /* @__PURE__ */ new Map();
function hn(e) {
	return mn.has(e) || mn.set(e, pn(e)), mn.get(e)();
}
//#endregion
//#region src/computedProperties/json.ts
function J() {
	let e = u(Je), t = u(Ze);
	if (!en(e) || !en(t)) throw Error("fs and savePath must be provided");
	return {
		jsonElement: k(() => e.value.jsonElement),
		layoutElement: k(() => e.value.uiElement),
		savePath: t
	};
}
function gn(...e) {
	return be.has(...e) ? be.get(...e) : null;
}
function _n(e) {
	return t(() => U(e.value.scope, -2));
}
function vn(e) {
	let n = bn(_n(e).value + "/required", !0);
	return t(() => {
		if (e.value.options?.forceRequired) return !0;
		let t = ut(e.value.scope);
		return !!(n.value !== void 0 && Array.isArray(n.value) && n.value.includes(t));
	});
}
function yn(e) {
	let t = e.toLowerCase().split("_");
	return t.forEach((e, n) => {
		e && (t[n] = (e[0]?.toUpperCase() ?? "") + e.slice(1));
	}), t.join(" ");
}
function Y(e, t = "items", n = "") {
	return e.replace(RegExp(`(?<=${n})\\.${it}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}`, "g"), "/" + t);
}
function X(e) {
	let t = e || u(qe);
	if (!t) throw Error("Form ID provider not found");
	return {
		formStructureStore: bt(t),
		formDataStore: hn(t)
	};
}
function bn(e, n = !1) {
	return t(() => {
		let t = e, { jsonSchema: r } = B(X().formStructureStore);
		return r.value ? (t = Y(t), gn(r.value || {}, t) || (n || console.error("No json data under scope " + e), null)) : null;
	});
}
function xn(e, t) {
	let { jsonSchema: n } = B(X(t).formStructureStore), r = Y(e);
	return gn(n.value || {}, r)?.type === "array";
}
function Sn(e) {
	return e.reduce((e, t) => {
		let n = !(typeof t == "string" && ct(t));
		return e || n;
	}, !1);
}
function Cn(e) {
	let { jsonSchema: n } = B(X().formStructureStore), r = bn(e.value.scope), i = vn(e), a = t(() => i.value && r.value?.type !== "object");
	return t(() => n.value ? (r.value?.title || yn(e.value.scope.split("/").pop() || "")).concat(a.value ? "*" : "") : "");
}
//#endregion
//#region src/computedProperties/misc.ts
function Z(e) {
	return t(() => ("vjf_control_for_" + e).replace(/\//g, "_"));
}
function wn() {
	return Math.random().toString(36).substring(7);
}
//#endregion
//#region src/renderings/bootstrap/HelpPopover.vue
var Tn = /* @__PURE__ */ l({
	__name: "HelpPopover",
	setup(e) {
		let { layoutElement: t } = J();
		return (e, i) => A(t)?.options?.help?.text ? (x(), n(A(pe), { key: 0 }, {
			target: P(() => [c(A(I), {
				pill: "",
				variant: A(t).options.help.variant ?? "primary"
			}, {
				default: P(() => [s(D(A(t).options.help.label ?? "i"), 1)]),
				_: 1
			}, 8, ["variant"])]),
			default: P(() => [s(" " + D(A(t).options.help.text), 1)]),
			_: 1
		})) : r("", !0);
	}
}), En = /* @__PURE__ */ l({
	__name: "CheckboxControl",
	setup(e) {
		let { formDataStore: t } = X(), { formData: r } = B(t), { layoutElement: i, savePath: a } = J(), o = Z(a), l = Cn(i);
		return (e, t) => (x(), n(A(z), {
			id: A(o),
			modelValue: A(r)[A(a)],
			"onUpdate:modelValue": t[0] ||= (e) => A(r)[A(a)] = e,
			class: "vjf_checkbox"
		}, {
			default: P(() => [s(D(A(l)) + " ", 1), c(Tn)]),
			_: 1
		}, 8, ["id", "modelValue"]));
	}
}), Dn = /* @__PURE__ */ l({
	__name: "ErrorViewer",
	props: { header: {} },
	setup(e) {
		let t = e;
		return (e, r) => (x(), n(A(R), {
			class: "vjw_errorViewer",
			"header-bg-variant": "danger",
			"header-text-variant": "white",
			header: t.header,
			"header-border-variant": "danger",
			"border-variant": "danger"
		}, {
			default: P(() => [T(e.$slots, "default")]),
			_: 3
		}, 8, ["header"]));
	}
}), On = { class: "text-muted" }, kn = /* @__PURE__ */ l({
	__name: "DefaultControl",
	setup(e) {
		let { jsonElement: t } = J();
		return (e, r) => (x(), n(Dn, { header: "Unsupported" }, {
			default: P(() => [r[0] ||= a("p", null, "This field type is not supported!", -1), a("p", On, D(A(t)), 1)]),
			_: 1
		}));
	}
}), An = /* @__PURE__ */ l({
	__name: "VJFButton",
	props: { layoutElement: {} },
	setup(e) {
		let r = e, i = st(), { formStructureStore: a } = X(), { buttonWaiting: o } = B(a);
		o.value[i] = !1;
		let s = a.getComponent("Button"), c = t(() => {
			let e = JSON.stringify({
				...r.layoutElement.options?.submitOptions,
				id: i
			});
			return encodeURIComponent(e);
		});
		return (t, r) => (x(), n(E(A(s)), {
			"layout-element": e.layoutElement,
			"submit-options": c.value,
			formnovalidate: e.layoutElement.options?.formnovalidate ? "formnovalidate" : void 0,
			waiting: A(o)[A(i)]
		}, null, 8, [
			"layout-element",
			"submit-options",
			"formnovalidate",
			"waiting"
		]));
	}
}), jn = /* @__PURE__ */ l({
	__name: "ButtonGroup",
	props: { layoutElement: {} },
	setup(t) {
		return (r, a) => (x(), n(A(te), {
			class: "w-100",
			vertical: t.layoutElement.options?.vertical
		}, {
			default: P(() => [(x(!0), i(e, null, w(t.layoutElement.buttons, (e) => (x(), n(An, {
				key: e.text,
				"layout-element": e
			}, null, 8, ["layout-element"]))), 128))]),
			_: 1
		}, 8, ["vertical"]));
	}
}), Mn = /* @__PURE__ */ V({ getStep: () => Nn });
function Nn(e) {
	return t(() => e.value.type === "integer" ? e.value.multipleOf || 1 : e.value.multipleOf || 1e-22);
}
//#endregion
//#region src/renderings/bootstrap/controls/NumberControl.vue
var Pn = /* @__PURE__ */ l({
	__name: "NumberControl",
	setup(e) {
		let { formDataStore: t } = X(), { formData: r } = B(t), { jsonElement: i, layoutElement: a, savePath: o } = J(), s = Z(o), c = Nn(i);
		return (e, t) => (x(), n(A(ae), {
			id: A(s),
			modelValue: A(r)[A(o)],
			"onUpdate:modelValue": t[0] ||= (e) => A(r)[A(o)] = e,
			modelModifiers: { number: !0 },
			class: "vjf_input",
			step: A(c),
			min: A(i).minimum,
			max: A(i).maximum,
			type: A(G)(A(a), "range", !1) ? "range" : "number"
		}, null, 8, [
			"id",
			"modelValue",
			"step",
			"min",
			"max",
			"type"
		]));
	}
});
//#endregion
//#region src/computedProperties/css.ts
function Q(e, ...n) {
	return t(() => {
		let t = " " + n.join(" "), r = e;
		return d(r) && (r = r.value), G(r, "cssClass", "") + t;
	});
}
//#endregion
//#region src/components/LayoutElements/htmlRenderer.vue?vue&type=script&setup=true&lang.ts
var Fn = ["innerHTML"], In = /* @__PURE__ */ l({
	__name: "htmlRenderer",
	props: { layoutElement: {} },
	setup(e) {
		let n = e, r = t(() => je(n.layoutElement.htmlData, {
			allowedTags: je.defaults.allowedTags.concat("img", "a", "svg"),
			allowedAttributes: {
				...je.defaults.allowedAttributes,
				"*": [
					"style",
					"class",
					"aria-*"
				]
			}
		}));
		return (e, t) => (x(), i("span", {
			class: "vjf_htmlRenderer",
			innerHTML: r.value
		}, null, 8, Fn));
	}
}), Ln = {}, Rn = {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16"
};
function zn(e, t) {
	return x(), i("svg", Rn, [...t[0] ||= [a("path", {
		fill: "currentColor",
		d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8L4.646 5.354a.5.5 0 0 1 0-.708"
	}, null, -1)]]);
}
var Bn = /* @__PURE__ */ H(Ln, [["render", zn], ["__scopeId", "data-v-8898cb0d"]]), Vn = {}, Hn = {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16"
};
function Un(e, t) {
	return x(), i("svg", Hn, [...t[0] ||= [a("path", {
		fill: "currentColor",
		d: "M7 2a1 1 0 1 1-2 0a1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0M7 5a1 1 0 1 1-2 0a1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0M7 8a1 1 0 1 1-2 0a1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0a1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0a1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0"
	}, null, -1)]]);
}
var Wn = /* @__PURE__ */ H(Vn, [["render", Un], ["__scopeId", "data-v-451bf0ec"]]), Gn = ["id"], Kn = { class: "handle" }, qn = /* @__PURE__ */ H(/* @__PURE__ */ l({
	__name: "ArrayItem",
	props: {
		scope: {},
		index: {},
		itemID: {},
		baseSavePath: {},
		allowRemove: { type: Boolean },
		uiSchema: {}
	},
	emits: ["delete"],
	setup(e, { emit: n }) {
		let r = e, o = lt(r.baseSavePath, r.itemID);
		S(Xe, o);
		let s = t(() => {
			let e = r.uiSchema || {
				type: "Control",
				scope: "",
				options: { label: !1 }
			};
			return e.scope = r.scope + "." + r.itemID, e;
		}), l = n, u = X().formStructureStore.getComponent("ArrayButton");
		return (t, n) => (x(), i("div", {
			id: e.itemID,
			class: "vjf_arrayItem"
		}, [c(sr, {
			"layout-element": s.value,
			"in-array-item": ""
		}, {
			prepend: P(() => [a("div", Kn, [c(Wn)])]),
			append: P(() => [c(A(u), {
				variant: "outline-danger",
				disabled: !e.allowRemove,
				"aria-label": "Delete Item",
				onClick: n[0] ||= (t) => l("delete", e.itemID, A(o))
			}, {
				default: P(() => [c(Bn)]),
				_: 1
			}, 8, ["disabled"])]),
			_: 1
		}, 8, ["layout-element"])], 8, Gn));
	}
}), [["__scopeId", "data-v-3f5df992"]]), Jn = {}, Yn = {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16"
};
function Xn(e, t) {
	return x(), i("svg", Yn, [...t[0] ||= [a("path", {
		fill: "currentColor",
		d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"
	}, null, -1)]]);
}
var Zn = /* @__PURE__ */ H(Jn, [["render", Xn], ["__scopeId", "data-v-9a59b4f7"]]), Qn = { class: "vjf_label_wrapper" }, $n = ["for"], er = { class: "large-label" }, tr = { class: "vjf_array-help-icon-wrapper" }, nr = { key: 0 }, rr = ["id"], ir = { key: 0 }, ar = /* @__PURE__ */ l({
	__name: "ArrayControl",
	setup(e) {
		let { formStructureStore: o, formDataStore: l } = X(), d = o.getComponent("ErrorViewer"), f = o.getComponent("HelpPopover"), h = o.getComponent("ArrayButton"), g = o.getComponent("ConfirmationModal"), v = ee("delete-remaining-items-modal"), { formData: y, arrays: b } = B(l), { jsonSchema: S } = B(o), { jsonElement: w, layoutElement: T, savePath: E } = J(), O = u($e), k = Z(E), j = vn(T);
		function I(e = !1, t) {
			let n = it + st();
			if (!S.value) throw Error("jsonSchema is unexpectedly undefined");
			if (!en(E)) throw Error("savePath must be provided");
			y.value[E].push(n), y.value[`${E}.${n}`] = t ?? "", e || m().then(() => {
				let e = document.getElementById(k.value)?.querySelectorAll(".list-group > *");
				e && (e[e.length - 1]?.querySelector("input"))?.focus();
			});
		}
		function L(e = 0) {
			let t = (w.value.minItems || 0) + e;
			for (let e = y.value[E].length; e < t; e++) I(!0);
		}
		function te() {
			L(-1), I();
		}
		let R = Cn(T), z = C(!1), ne = C({
			animation: 200,
			group: `array-${R.value}`,
			disabled: !1,
			ghostClass: "ghost"
		});
		function re() {
			for (let e of y.value[E]) {
				let t = lt(E, e), n = Object.keys(y.value).filter((e) => e.startsWith(t));
				for (let e of n) delete y.value[e];
			}
			y.value[E] = [];
		}
		function ie(e, t) {
			if (y.value[E].length <= (w.value.minItems || 0) && y.value[E].length > 1) {
				if (j.value) return;
				v.value?.show();
				return;
			}
			let n = y.value[E].indexOf(e);
			n > -1 ? y.value[E].splice(n, 1) : console.warn("Could not find item with id", e, "in", y.value[E]), delete y.value[t];
		}
		function ae() {
			b.value[E] = {
				key: E,
				jsonSchema: w.value,
				required: j.value
			};
		}
		function oe() {
			if (!y.value[E]) y.value[E] = [];
			else if (Sn(y.value[E])) {
				let e = y.value[E];
				y.value[E] = [];
				for (let t of e) I(!0, t);
			}
			ae(), j.value && L(), T.value.options?.maxFileSize && nt(T.value.scope + "/items", { options: { maxFileSize: T.value.options.maxFileSize } });
		}
		N(() => y.value[E], () => {
			y.value[E] || oe();
		}), N([() => j.value, () => w.value.minItems], () => {
			j.value && L();
		}), N([() => j.value, () => w.value], ae);
		let se = t(() => y.value[E].length < (w.value.maxItems || Number.MAX_VALUE)), ce = t(() => !j.value || y.value[E].length > (w.value.minItems || 0)), le = t(() => ct(T.value.scope.split(".").pop() || ""));
		return _(oe), (e, t) => (x(), i("div", null, [
			a("div", Qn, [le.value ? r("", !0) : F((x(), i("label", {
				key: 0,
				for: A(k)
			}, [a("span", er, D(A(R)), 1)], 8, $n)), [[M, A(G)(A(T), "label", !0)]]), a("div", tr, [c(A(f))])]),
			A(w).description ? (x(), i("p", nr, D(A(w).description), 1)) : r("", !0),
			typeof A(w).items == "object" && "type" in A(w).items ? (x(), i("div", {
				key: 1,
				id: A(k),
				class: "vjf_array"
			}, [c(A(Ne), p({
				key: "draggable",
				modelValue: A(y)[A(E)],
				"onUpdate:modelValue": t[0] ||= (e) => A(y)[A(E)] = e,
				class: "list-group",
				handle: ".handle",
				"item-key": (e) => e
			}, ne.value, {
				"component-data": {
					tag: "div",
					type: "transition-group",
					name: z.value ? null : "flip-list"
				},
				onStart: t[1] ||= (e) => z.value = !0,
				onEnd: t[2] ||= (e) => z.value = !1
			}), {
				item: P(({ element: e, index: t }) => [(x(), i("div", {
					key: e,
					class: "draggable-array-item"
				}, [c(qn, {
					scope: A(T).scope,
					"base-save-path": A(E),
					index: t,
					"item-i-d": e,
					"allow-remove": ce.value,
					onDelete: ie
				}, null, 8, [
					"scope",
					"base-save-path",
					"index",
					"item-i-d",
					"allow-remove"
				])]))]),
				_: 1
			}, 16, [
				"modelValue",
				"item-key",
				"component-data"
			]), c(A(h), {
				variant: "outline-primary",
				class: "w-100",
				disabled: !se.value,
				"aria-label": "Add Item",
				onClick: te
			}, {
				default: P(() => [A(G)(A(T), "addButtonText") ? (x(), i("span", ir, D(A(G)(A(T), "addButtonText")), 1)) : (x(), n(Zn, { key: 1 }))]),
				_: 1
			}, 8, ["disabled"])], 8, rr)) : (x(), n(A(d), {
				key: 2,
				id: A(k),
				header: "Error"
			}, {
				default: P(() => [...t[3] ||= [s(" The type of the array's items is missing in the schema ", -1)]]),
				_: 1
			}, 8, ["id"])),
			c(A(g), {
				ref: "delete-remaining-items-modal",
				title: A(O)?.getString("modals.delete-remaining-items.title") || "",
				"confirm-button-text": A(O)?.getString("modals.delete-remaining-items.confirm"),
				"confirm-button-variant": "danger",
				"cancel-button-text": A(O)?.getString("modals.delete-remaining-items.cancel"),
				onConfirm: re
			}, {
				default: P(() => [s(D(A(O)?.getStringTemplate("modals.delete-remaining-items.text", A(w).minItems)), 1)]),
				_: 1
			}, 8, [
				"title",
				"confirm-button-text",
				"cancel-button-text"
			])
		]));
	}
}), or = { key: 1 }, sr = /* @__PURE__ */ l({
	__name: "Control",
	props: {
		layoutElement: {},
		inArrayItem: { type: Boolean }
	},
	setup(e) {
		let { formStructureStore: a, formDataStore: l } = X(), { jsonSchema: d, mappers: f, uiSchema: p } = B(a), m = a.getComponent("FormFieldWrapper"), _ = a.getComponent("ErrorViewer"), b = e, w = bn(b.layoutElement.scope), { formData: O, defaultFormData: k, cleanedFormData: j } = B(l), ee = C(!1);
		tt(b.layoutElement.options?.descendantControlOverrides);
		let M = u(Qe), F = u(Xe, void 0) || b.layoutElement.scope, I = C([]), L = C({
			jsonElement: w.value || {},
			uiElement: b.layoutElement
		});
		async function te() {
			let e = w.value || {}, t = b.layoutElement;
			t = rt(t, M);
			for (let n of I.value) {
				let r;
				Gt(n) ? r = n.map(e || {}, t) : Kt(n) && (r = await n.map(e || {}, t, O.value, j.value.json)), r ? (e = r.jsonElement, t = r.uiElement) : console.warn("Mapper failed", n);
			}
			L.value = {
				jsonElement: e || {},
				uiElement: t
			};
		}
		N([() => w.value, () => b.layoutElement], te, { immediate: !0 });
		let R = u(qe);
		if (!R) throw Error("formId is not provided");
		y(() => {
			if (!w.value || !b.layoutElement || !d.value || !p.value) return;
			let e = /* @__PURE__ */ new Set();
			I.value = f.value.map((e) => new e());
			for (let t of I.value) if (Kt(t)) {
				t.registerSchemata(d.value, p.value, Y(b.layoutElement.scope), F, w.value, rt(b.layoutElement, M), R);
				for (let n of t.getDependencies()) e.has(n) || (e.add(n), Me(() => O.value[n], () => {
					te();
				}, {
					debounce: 50,
					deep: !1
				}));
			}
			te();
		});
		let z = t(() => {
			let e = {}, t = L.value.uiElement;
			return t.options?.preHtml && (e.pre = {
				type: "HTML",
				htmlData: t.options.preHtml
			}), t.options?.postHtml && (e.post = {
				type: "HTML",
				htmlData: t.options.postHtml
			}), e;
		}), ne = t(() => L.value.uiElement), re = vn(ne), ie = L.value.uiElement.options?.hidden ? "hiddenControl" : "", ae = t(() => {
			if (b.layoutElement.options && "textAlign" in b.layoutElement.options && b.layoutElement.options.textAlign) return `text-align: ${b.layoutElement.options.textAlign}`;
		}), oe = Q(L.value.uiElement, "vjf_control mb-3", ie);
		S(Je, L), S(Ze, F), S(Xe, void 0), S(et, b.inArrayItem ?? !1);
		let se = Z(F), ce = Cn(ne), le = t(() => {
			if (L.value.jsonElement?.enum !== void 0 && L.value.jsonElement.type !== "array") return G(L.value.uiElement, "displayAs") === "radiobuttons" || G(L.value.uiElement, "displayAs") === "buttons" ? a.getComponent("RadiobuttonControl") : a.getComponent("SelectControl");
			if (typeof L.value.jsonElement?.items == "object" && "enum" in L.value.jsonElement.items && L.value.jsonElement.type === "array") return a.getComponent("CheckboxGroupControl");
			if (L.value.jsonElement?.type === "array" && q(L.value.uiElement, "tags") && L.value.uiElement.options?.tags?.enabled) return a.getComponent("TagsControl");
			if (L.value.jsonElement?.type === "string" && L.value.jsonElement.format === "uri" || L.value.jsonElement?.type === "array" && Vt(L.value.jsonElement) && L.value.jsonElement.items.type === "string" && L.value.jsonElement.items.format === "uri" && L.value.uiElement.options?.displayAsSingleUploadField) return a.getComponent("FileControl");
			switch (L.value.jsonElement?.type) {
				case "boolean": return a.getComponent("CheckboxControl");
				case "number":
				case "integer": return a.getComponent("NumberControl");
				case "object": return a.getComponent("ObjectControl");
				case "string": return a.getComponent("StringControl");
				case "array": return ar;
				default: return a.getComponent("DefaultControl");
			}
		});
		return N(w, () => {
			w.value === void 0 && (ee.value = b.layoutElement.scope);
		}), y(() => {
			k.value[F] !== void 0 && (O.value[F] = k.value[F]);
		}), v(() => {
			O.value[F] = void 0;
		}), (t, a) => ee.value ? (x(), i("div", or, [c(A(_), { header: "Error" }, {
			default: P(() => [s(" Invalid Json Pointer: " + D(ee.value), 1)]),
			_: 1
		})])) : (x(), i("div", {
			key: 0,
			class: h(A(oe))
		}, [
			z.value.pre ? (x(), n(In, {
				key: 0,
				"layout-element": z.value.pre
			}, null, 8, ["layout-element"])) : r("", !0),
			(x(), n(E(A(m)), {
				label: A(ce),
				"label-for": A(se)
			}, o({
				default: P(() => [(x(), n(E(le.value), {
					name: L.value.uiElement.scope,
					disabled: L.value.uiElement.options?.disabled,
					placeholder: L.value.uiElement.options?.placeholder,
					autocomplete: A(G)(L.value.uiElement, "autocomplete", "on"),
					required: A(re) || e.inArrayItem,
					style: g(ae.value),
					"aria-label": e.inArrayItem ? "List item" : void 0
				}, null, 8, [
					"name",
					"disabled",
					"placeholder",
					"autocomplete",
					"required",
					"style",
					"aria-label"
				]))]),
				_: 2
			}, [t.$slots.prepend ? {
				name: "prepend",
				fn: P(() => [T(t.$slots, "prepend")]),
				key: "0"
			} : void 0, t.$slots.append ? {
				name: "append",
				fn: P(() => [T(t.$slots, "append")]),
				key: "1"
			} : void 0]), 1032, ["label", "label-for"])),
			z.value.post ? (x(), n(In, {
				key: 1,
				"layout-element": z.value.post
			}, null, 8, ["layout-element"])) : r("", !0)
		], 2));
	}
}), cr = {};
function lr(e, t) {
	return x(), i("hr");
}
var ur = /* @__PURE__ */ H(cr, [["render", lr]]), dr = /* @__PURE__ */ l({
	__name: "VerticalLayout",
	props: { layoutElement: {} },
	setup(r) {
		let a = r, o = Q(a.layoutElement, "vjf_verticalLayout"), s = t(() => It(a.layoutElement) ? dt(a.layoutElement.elements) : []);
		return (t, r) => (x(), i("div", { class: h(A(o)) }, [(x(!0), i(e, null, w(s.value, (e) => (x(), n(vr, {
			key: e.uuid,
			"layout-element": e
		}, null, 8, ["layout-element"]))), 128))], 2));
	}
}), fr = { key: 0 }, pr = {
	Control: sr,
	Divider: ur,
	Group: /* @__PURE__ */ H(/* @__PURE__ */ l({
		__name: "Group",
		props: { layoutElement: {} },
		setup(e) {
			let t = Q(e.layoutElement, "vjf_group");
			return (n, o) => (x(), i("fieldset", { class: h(A(t)) }, [
				F(a("legend", null, D(e.layoutElement.options?.label || "Unnamed group"), 513), [[M, e.layoutElement.options?.label]]),
				e.layoutElement.options?.description ? (x(), i("p", fr, D(e.layoutElement.options.description), 1)) : r("", !0),
				c(dr, {
					class: "vjf_fieldset-content vjf_indented",
					"layout-element": {
						...e.layoutElement,
						type: "VerticalLayout"
					}
				}, null, 8, ["layout-element"])
			], 2));
		}
	}), [["__scopeId", "data-v-fcf61396"]]),
	HorizontalLayout: /* @__PURE__ */ l({
		__name: "HorizontalLayout",
		props: { layoutElement: {} },
		setup(r) {
			let a = r, o = Q(a.layoutElement, "vjf_horizontalLayout"), s = t(() => It(a.layoutElement) ? dt(a.layoutElement.elements) : []);
			return (t, r) => (x(), i("div", { class: h(A(o)) }, [(x(!0), i(e, null, w(s.value, (e) => (x(), n(vr, {
				key: e.uuid,
				"layout-element": e
			}, null, 8, ["layout-element"]))), 128))], 2));
		}
	}),
	VerticalLayout: dr,
	htmlRenderer: In
}, mr = {};
function hr(e, t) {
	return "Unknown Component";
}
var gr = /* @__PURE__ */ H(mr, [["render", hr]]), _r = {
	vjfButtonGroup: /* @__PURE__ */ l({
		__name: "ButtonGroup",
		props: { layoutElement: {} },
		setup(e) {
			let t = X().formStructureStore.getComponent("Buttongroup");
			return (r, i) => (x(), n(E(A(t)), { "layout-element": e.layoutElement }, null, 8, ["layout-element"]));
		}
	}),
	vjfButton: An
}, vr = /* @__PURE__ */ l({
	__name: "FormWrap",
	props: { layoutElement: {} },
	setup(e) {
		let { formStructureStore: t } = X(), i = t.getComponent("showOnWrapper"), a = u(qe);
		if (!a) throw Error("`formIdProviderKey` is not provided.");
		let o = e;
		function s(e) {
			switch (e) {
				case "Control": return pr.Control;
				case "VerticalLayout": return pr.VerticalLayout;
				case "HorizontalLayout": return pr.HorizontalLayout;
				case "Group": return pr.Group;
				case "HTML": return pr.htmlRenderer;
				case "Divider": return pr.Divider;
				case "Button": return _r.vjfButton;
				case "Buttongroup": return _r.vjfButtonGroup;
				case "Modal": return t.getComponent("Modal");
				default: return gr;
			}
		}
		let c = f(s(o.layoutElement.type)), l = o.layoutElement, d = u(Qe);
		l.type === "Control" && rt(l, d);
		let p = jt(l, d, a);
		return (t, a) => (x(), n(A(i), { visible: A(p) }, {
			default: P(() => [A(p) ? (x(), n(E(A(c)), {
				key: 0,
				"layout-element": e.layoutElement
			}, null, 8, ["layout-element"])) : r("", !0)]),
			_: 1
		}, 8, ["visible"]));
	}
}), yr = ["id"], br = { key: 0 }, xr = { class: "vjf_object_help" }, Sr = { key: 1 }, Cr = { class: "vjf_indented" }, wr = /* @__PURE__ */ H(/* @__PURE__ */ l({
	__name: "ObjectControl",
	setup(o) {
		let { jsonElement: l, layoutElement: u, savePath: d } = J(), f = Z(d), p = Q(u, "vjf_object"), m = Cn(u), g = t(() => ft(l.value, { scopeBase: u.value.scope }).layout.elements.filter((e) => e.type === "Control"));
		return (t, o) => (x(), i("fieldset", {
			id: A(f),
			class: h(A(p))
		}, [
			A(u).options?.label !== !1 && A(m) ? (x(), i("legend", br, [s(D(A(m)) + " ", 1), a("span", xr, [c(Tn)])])) : r("", !0),
			A(l).description ? (x(), i("p", Sr, D(A(l).description), 1)) : r("", !0),
			a("div", Cr, [(x(!0), i(e, null, w(g.value, (e) => (x(), n(vr, {
				key: e.scope,
				"layout-element": e
			}, null, 8, ["layout-element"]))), 128))])
		], 10, yr));
	}
}), [["__scopeId", "data-v-bbf0e2ae"]]), Tr = /* @__PURE__ */ l({
	__name: "TagsControl",
	setup(e) {
		let { formDataStore: t } = X(), { formData: r } = B(t), { layoutElement: i, savePath: a } = J(), o = Z(a);
		return (e, t) => (x(), n(A(ce), {
			id: A(o),
			modelValue: A(r)[A(a)],
			"onUpdate:modelValue": t[0] ||= (e) => A(r)[A(a)] = e,
			variant: "",
			separator: " ",
			class: "vjf_tags",
			"tag-pills": A(q)(A(i), "tags") && A(i).options?.tags?.pills,
			"tag-variant": A(q)(A(i), "tags") ? A(i).options?.tags?.variant : void 0
		}, null, 8, [
			"id",
			"modelValue",
			"tag-pills",
			"tag-variant"
		]));
	}
});
//#endregion
//#region src/formControlInputValidation/CheckboxGroupValidation.ts
function Er(e) {
	let t = `input[type='checkbox'][name='${e}']`;
	document.querySelectorAll(t).forEach((e) => {
		sn(e) && e.setCustomValidity("");
	});
}
function Dr(e, t, n = !1) {
	let r = `input[type='checkbox'][name='${t}']`;
	n ? r += ":checked" : r += ":not(:checked)";
	let i = document.querySelector(r);
	sn(i) && i.setCustomValidity(e);
}
function Or(e, t, n, r, i) {
	if (Er(r), t === void 0) return !e;
	if (!Ht(n)) throw Error("CheckboxGroupControl requires enum values for items");
	let a = n.minItems ?? 0, o = n.maxItems ?? n.items.enum.length;
	if (t.length < a) {
		let e;
		return e = a === 1 ? i?.getString("errors.checkboxGroup.selectAtLeastOne") : i?.getStringTemplate("errors.checkboxGroup.selectAtLeast", a), Dr(e || "", r, !1), !1;
	}
	if (t.length > o) {
		let e;
		return e = o === 1 ? i?.getString("errors.checkboxGroup.selectAtMostOne") : i?.getStringTemplate("errors.checkboxGroup.selectAtMost", o), Dr(e || "", r, !0), !1;
	}
	return !0;
}
//#endregion
//#region src/renderings/renderHelpers/B64File.ts
function kr(e) {
	let t = atob(e), n = t.length, r = new Uint8Array(n);
	for (let e = 0; e < n; e++) r[e] = t.charCodeAt(e);
	return r;
}
var $ = class e {
	data;
	b64;
	constructor(e) {
		this.b64 = e, this.data = this.destructure();
	}
	destructure() {
		let e = this.b64.indexOf(",");
		if (e === -1) throw Error("Invalid base64 string");
		let t = this.b64.slice(0, e), n = this.b64.slice(e + 1), r = t.split(";");
		if (!r[0].startsWith("data:") || r[r.length - 1] !== "base64") throw Error("Invalid base64 string");
		let i = r[0].slice(5);
		if (!i) throw Error("Invalid base64 string");
		let a = r.find((e) => e.startsWith("name="));
		if (!a) return {
			mimeType: i,
			b64data: n
		};
		let o = a.slice(5), s = o.lastIndexOf(".");
		return {
			mimeType: i,
			filename: decodeURIComponent(s === -1 ? o : o.slice(0, s)),
			extension: s === -1 ? void 0 : o.slice(s + 1),
			b64data: n
		};
	}
	getBuffer() {
		return kr(this.data.b64data);
	}
	getBlob() {
		return new Blob([this.getBuffer()], { type: this.data.mimeType });
	}
	static calculateFileNameWithExtension(e, t) {
		return e !== void 0 && t !== void 0 ? `${e}.${t}` : e === void 0 ? t === void 0 ? "" : `.${t}` : e;
	}
	getFile() {
		return new File([this.getBlob()], this.getFileNameExtension(), { type: this.data.mimeType });
	}
	getMimeType() {
		return this.data.mimeType;
	}
	getFileNameExtension() {
		let { filename: t, extension: n } = this.data;
		return e.calculateFileNameWithExtension(t, n);
	}
	getFileName() {
		let { filename: e } = this.data;
		return e ?? "";
	}
	getExtension() {
		let { extension: e } = this.data;
		return e ?? "";
	}
	getBase64Data() {
		return this.data.b64data;
	}
	getBase64Uri() {
		return this.b64;
	}
	equals(t, n = !0) {
		return e.equals(this, t, n);
	}
	static fromFile(t) {
		return new Promise((n, r) => {
			let i = new FileReader();
			i.onload = () => {
				let r = i.result.split(",")[1], a = t.name.lastIndexOf("."), o = a === -1 ? t.name : t.name.slice(0, a), s = a === -1 ? "" : t.name.slice(a + 1), c = e.calculateFileNameWithExtension(o, s), l = "";
				c && (l = `;name=${encodeURIComponent(o)}.${s}`), n(new e(`data:${t.type}${l};base64,${r}`));
			}, i.onerror = r, i.readAsDataURL(t);
		});
	}
	static equals(e, t, n = !0) {
		return n ? e.getMimeType() === t.getMimeType() && e.getFileNameExtension() === t.getFileNameExtension() && e.getBase64Data() === t.getBase64Data() : e.getBase64Data() === t.getBase64Data();
	}
}, Ar = /* @__PURE__ */ V({
	getAcceptedFileTypes: () => Pr,
	getEnrichedLayoutElement: () => Fr,
	getMaxNumberOfFiles: () => Nr,
	getMinNumberOfFiles: () => Mr,
	getMultiple: () => jr
});
function jr(e) {
	return t(() => e.value.type === "array");
}
function Mr(e, n) {
	return t(() => Math.max(e.value.minItems ?? 0, +!!n));
}
function Nr(e) {
	return t(() => e.value.maxItems ?? 2 ** 53 - 1);
}
function Pr(e) {
	return t(() => {
		let t = G(e.value, "acceptedFileType", "*");
		if (!(t === "*" || Array.isArray(t) && t.includes("*"))) return t;
	});
}
function Fr(e, n) {
	return t(() => ({
		...e.value,
		options: {
			...e.value.options,
			...G(e.value, "descendantControlOverrides")?.[n + "/items"]?.options || {}
		}
	}));
}
//#endregion
//#region src/renderings/renderHelpers/FormfieldWrapper.ts
var Ir = /* @__PURE__ */ V({
	getHasPrependOrAppend: () => Lr,
	getIsObjectOrArrayViewComputed: () => zr
});
function Lr(e, n) {
	return t(() => !!(e.prepend || e.append || n.value.options?.prepend || n.value.options?.append));
}
function Rr(e, t) {
	return e.type === "object" || e.type === "array" && !(Vt(e) && e.items.enum) && !e.enum && !(q(t, "tags") && t.options.tags?.enabled) && !(Vt(e) && e.items.type === "string" && e.items.format === "uri" && t.options?.displayAsSingleUploadField);
}
function zr(e, n) {
	return t(() => Rr(e.value, n.value));
}
//#endregion
//#region src/renderings/renderHelpers/StringControl.ts
var Br = /* @__PURE__ */ V({
	getIsMultiLine: () => Hr,
	getNumberOfLines: () => Ur,
	getType: () => Vr
});
function Vr(e, n) {
	return t(() => {
		let t = n.value.options?.format || e.value.format?.replace("date-time", "datetime-local");
		if (Wt(t)) return t;
	});
}
function Hr(e) {
	return t(() => {
		let t = e.value.options?.multi;
		return typeof t == "number" ? t > 1 : !!t;
	});
}
function Ur(e) {
	return t(() => {
		let t = e.value.options?.multi;
		if (typeof t == "number") return t;
	});
}
//#endregion
//#region src/renderings/renderHelpers/SelectControl.ts
var Wr = /* @__PURE__ */ V({
	createInvalidValueWatch: () => Kr,
	getOptions: () => Gr
});
function Gr(e, n) {
	return t(() => e.value.enum ? q(n.value, "enumTitles") ? e.value.enum.map((e) => typeof e != "string" && typeof e != "number" ? e : {
		value: e,
		text: (n.value.options?.enumTitles)[e] || e
	}) : e.value.enum : []);
}
function Kr(e, t, n) {
	N(() => e.value.enum, () => {
		e.value.enum && !e.value.enum.includes(t.value[n]) && (t.value[n] = void 0);
	});
}
//#endregion
//#region src/renderings/renderHelpers/CheckboxGroupControl.ts
var qr = /* @__PURE__ */ V({ getOptions: () => Jr });
function Jr(e, n) {
	return t(() => Ht(e.value) && e.value.items.enum.map((e) => {
		let t = (G(n.value, "enumTitles") || {})[e] || e;
		return {
			value: e,
			text: String(t)
		};
	}) || []);
}
//#endregion
//#region src/renderings/renderHelpers/Button.ts
var Yr = /* @__PURE__ */ V({
	getHtmlButtonType: () => Xr,
	getMaxPages: () => Zr,
	getWizardHandler: () => Qr
});
function Xr(e) {
	return t(() => {
		if ([
			"submit",
			"reset",
			"button"
		].includes(e.buttonType)) return e.buttonType;
	});
}
function Zr(e) {
	return t(() => e.value?.type === "Wizard" ? e.value.pages.length - 1 : 2 ** 53 - 1);
}
function Qr(e, t, n, r, i) {
	return () => {
		if (e.buttonType === "previousWizardPage") t.value = Math.max(t.value - 1, 0);
		else if (e.buttonType === "nextWizardPage") {
			if (n.value[t.value]?.()) r.value = !1;
			else return;
			t.value = Math.min(t.value + 1, i.value);
		}
	};
}
//#endregion
//#region src/renderings/renderHelpers/index.ts
var $r = /* @__PURE__ */ V({
	Base64String: () => $,
	Button: () => Yr,
	CheckboxGroupControl: () => qr,
	FileControl: () => Ar,
	FormWrap: () => vr,
	FormfieldWrapper: () => Ir,
	NumberControl: () => Mn,
	ProviderKeys: () => Ke,
	SelectControl: () => Wr,
	StringControl: () => Br,
	arrayContainsValue: () => Sn,
	cleanScope: () => Y,
	computedCssClass: () => Q,
	computedLabel: () => Cn,
	controlID: () => Z,
	getComputedGrandparentJsonPath: () => _n,
	getComputedJsonElement: () => bn,
	getComputedRequired: () => vn,
	getJsonPointerSafe: () => gn,
	getOption: () => G,
	getRandomId: () => wn,
	getStores: () => X,
	injectJsonData: () => J,
	isArray: () => xn
}), ei = /* @__PURE__ */ l({
	__name: "CheckboxGroupControl",
	props: { required: { type: Boolean } },
	setup(e) {
		let { formDataStore: r, formStructureStore: i } = X(), a = e, { formData: o } = B(r), { formStateWasValidated: s } = B(i), c = u($e), { jsonElement: l, layoutElement: d, savePath: f } = J(), p = Z(f), m = Jr(l, d), h = C(!0), g = C([]), _ = () => {
			h.value = Or(a.required, g.value, l.value, f, c);
		};
		N(g, (e) => {
			_(), Ht(l.value) && (o.value[f] = l.value.items.enum.filter((t) => e.includes(t)));
		}), N(() => o.value[f], (e) => {
			let t;
			nn(e) && Array.isArray(e) && (t = e?.map((e) => ct(e) ? o.value[lt(f, e)] : e), JSON.stringify(t) !== JSON.stringify(g.value) && (g.value = t));
		}, { immediate: !0 }), y(_);
		let v = t(() => {
			if (s.value) return h.value;
		});
		return (e, t) => (x(), n(A(ne), {
			id: A(p),
			modelValue: g.value,
			"onUpdate:modelValue": t[0] ||= (e) => g.value = e,
			options: A(m),
			class: "vjf_checkboxGroup",
			required: !1,
			state: v.value,
			stacked: A(G)(A(d), "stacked"),
			buttons: A(G)(A(d), "displayAs") === "buttons",
			switches: A(G)(A(d), "displayAs") === "switches",
			"button-variant": A(G)(A(d), "buttonVariant") || "primary"
		}, null, 8, [
			"id",
			"modelValue",
			"options",
			"state",
			"stacked",
			"buttons",
			"switches",
			"button-variant"
		]));
	}
}), ti = /* @__PURE__ */ H(/* @__PURE__ */ l({
	__name: "RadiobuttonControl",
	setup(e) {
		let { formDataStore: t } = X(), { formData: r } = B(t), { jsonElement: i, layoutElement: a, savePath: o } = J(), s = Z(o), c = Gr(i, a);
		return Kr(i, r, o), (e, t) => (x(), n(A(oe), {
			id: A(s),
			modelValue: A(r)[A(o)],
			"onUpdate:modelValue": t[0] ||= (e) => A(r)[A(o)] = e,
			options: A(c),
			class: "vjf_radioGroup w-100",
			buttons: A(G)(A(a), "displayAs") === "buttons",
			"button-variant": A(G)(A(a), "buttonVariant") || "primary",
			stacked: A(G)(A(a), "stacked")
		}, null, 8, [
			"id",
			"modelValue",
			"options",
			"buttons",
			"button-variant",
			"stacked"
		]));
	}
}), [["__scopeId", "data-v-4741ee0c"]]), ni = /* @__PURE__ */ l({
	__name: "SelectControl",
	setup(e) {
		let { formDataStore: t } = X(), { formData: r } = B(t), { jsonElement: i, layoutElement: a, savePath: o } = J(), s = Z(o), c = Gr(i, a);
		return Kr(i, r, o), (e, t) => (x(), n(A(se), {
			id: A(s),
			modelValue: A(r)[A(o)],
			"onUpdate:modelValue": t[0] ||= (e) => A(r)[A(o)] = e,
			options: A(c),
			class: "vjf_select"
		}, null, 8, [
			"id",
			"modelValue",
			"options"
		]));
	}
}), ri = /* @__PURE__ */ l({
	__name: "StringControl",
	setup(e) {
		let { formDataStore: t } = X(), { formData: r } = B(t), { jsonElement: i, layoutElement: a, savePath: o } = J(), s = Z(o), c = Vr(i, a), l = Hr(a), u = Ur(a);
		return (e, t) => A(l) ? (x(), n(A(le), {
			key: 0,
			id: A(s),
			modelValue: A(r)[A(o)],
			"onUpdate:modelValue": t[0] ||= (e) => A(r)[A(o)] = e,
			class: "vjf_textarea",
			rows: A(u),
			minlength: A(i).minLength,
			maxlength: A(i).maxLength
		}, null, 8, [
			"id",
			"modelValue",
			"rows",
			"minlength",
			"maxlength"
		])) : (x(), n(A(ae), {
			key: 1,
			id: A(s),
			modelValue: A(r)[A(o)],
			"onUpdate:modelValue": t[1] ||= (e) => A(r)[A(o)] = e,
			class: "vjf_input",
			minlength: A(i).minLength,
			maxlength: A(i).maxLength,
			step: A(i).multipleOf,
			min: A(i).minimum,
			max: A(i).maximum,
			type: A(c),
			pattern: A(i).pattern
		}, null, 8, [
			"id",
			"modelValue",
			"minlength",
			"maxlength",
			"step",
			"min",
			"max",
			"type",
			"pattern"
		]));
	}
}), ii = { key: 1 }, ai = /* @__PURE__ */ l({
	__name: "FormFieldWrapper",
	props: {
		label: {},
		labelFor: {}
	},
	setup(e) {
		let o = e, l = j(), { jsonElement: u, layoutElement: d, savePath: f } = J(), p = zr(u, d), m = Lr(l, d), h = t(() => u.value.type === "boolean" || d.value.options?.label === !1 || p.value);
		return (e, t) => (x(), n(A(ie), {
			"label-for": o.labelFor,
			description: A(p) ? void 0 : A(u).description
		}, {
			label: P(() => [F(a("span", null, [s(D(o.label) + " ", 1), c(Tn)], 512), [[M, !h.value]])]),
			default: P(() => [A(m) ? (x(), n(A(ue), { key: 0 }, {
				default: P(() => [
					T(e.$slots, "prepend", {}, () => [A(d).options?.prepend ? (x(), n(A(de), { key: 0 }, {
						default: P(() => [s(D(A(d).options.prepend), 1)]),
						_: 1
					})) : r("", !0)]),
					T(e.$slots, "default"),
					T(e.$slots, "append", {}, () => [A(d).options?.append ? (x(), n(A(de), { key: 0 }, {
						default: P(() => [s(D(A(d).options.append), 1)]),
						_: 1
					})) : r("", !0)])
				]),
				_: 3
			})) : (x(), i("div", ii, [T(e.$slots, "default")]))]),
			_: 3
		}, 8, ["label-for", "description"]));
	}
}), oi = { key: 0 }, si = { key: 1 }, ci = /* @__PURE__ */ l({
	__name: "VJFButton",
	props: {
		layoutElement: {},
		waiting: { type: Boolean }
	},
	setup(e) {
		let { formStructureStore: t } = X(), r = e, { currentWizardPage: a, uiSchema: o, wizardValidateFunctions: s, formStateWasValidated: l } = B(t), u = Q(r.layoutElement), d = Xr(r.layoutElement), f = Zr(o), p = Qr(r.layoutElement, a, s, l, f);
		return (t, r) => (x(), n(A(L), {
			variant: e.layoutElement.options?.variant,
			type: A(d),
			class: h(A(u)),
			disabled: e.layoutElement.options?.disabled,
			onClick: A(p)
		}, {
			default: P(() => [e.waiting ? (x(), i("span", si, [c(A(me), { small: "" })])) : (x(), i("span", oi, D(e.layoutElement.text), 1))]),
			_: 1
		}, 8, [
			"variant",
			"type",
			"class",
			"disabled",
			"onClick"
		]));
	}
});
//#endregion
//#region src/formControlInputValidation/UploadValidation.ts
function li(e, t, n, r, i, a, o, s) {
	if (!s) return !0;
	if (r.value && Array.isArray(e)) {
		if (a.value && (e?.length || 0) > a.value) return a.value === 1 ? s.setCustomValidity(o?.getStringTemplate("errors.fileUpload.onlyOne") || "") : s.setCustomValidity(o?.getStringTemplate("errors.fileUpload.tooManyFiles", a.value) || ""), !1;
		if (i.value && (e?.length || 0) < i.value && (t || e?.length > 0)) return i.value === 1 ? s.setCustomValidity(o?.getStringTemplate("errors.fileUpload.atLeastOne") || "") : s.setCustomValidity(o?.getStringTemplate("errors.fileUpload.tooFewFiles", i.value) || ""), !1;
	} else if (t && !e) return s.setCustomValidity(""), !1;
	if (n) {
		let t = [];
		e != null && (t = Array.isArray(e) ? e : [e]);
		let r = t.filter((e) => e.size > n);
		if (r.length > 0) return s.setCustomValidity(o?.getStringTemplate("errors.fileUpload.fileTooLarge", (n / 1024 / 1024).toFixed(2), r.map((e) => e.name).join(", ")) || ""), !1;
	}
	return s.setCustomValidity(""), !0;
}
//#endregion
//#region src/renderings/bootstrap/BootstrapComponents.ts
var ui = {
	showOnWrapper: Le,
	CheckboxControl: En,
	CheckboxGroupControl: ei,
	FileControl: /* @__PURE__ */ H(/* @__PURE__ */ l({
		__name: "FileControl",
		props: {
			required: { type: Boolean },
			placeholder: {}
		},
		setup(e) {
			let r = e, { formDataStore: i, formStructureStore: a } = X(), { formData: o } = B(i), { formStateWasValidated: s } = B(a), { jsonElement: c, layoutElement: l, savePath: d } = J(), f = Z(d), p = u($e), m = u(et), g = Fr(l, d), _ = jr(c), v = Mr(c, r.required), b = Nr(c), S = Pr(g), w = C(!0), T = C(), E = t(() => {
				if (s.value) return w.value;
			}), D = () => {
				w.value = li(T.value, r.required, g.value.options?.maxFileSize, _, v, b, p, document.querySelector(`input[name='${d}']`));
			};
			return N([
				T,
				() => c.value,
				() => g.value,
				() => _.value,
				() => v.value,
				() => b.value,
				() => r.required
			], D, { deep: !0 }), N(T, async (e) => {
				if (e) if (Array.isArray(e)) {
					let t = await Promise.all(e.map((e) => $.fromFile(e)));
					o.value[d] = t.map((e) => e.getBase64Uri());
				} else {
					let t = await $.fromFile(e);
					o.value[d] = t.getBase64Uri();
				}
				else _.value ? o.value[d] = [] : o.value[d] = void 0;
			}), N(() => o.value[d], async () => {
				if (_.value) {
					if (o.value[d] && Array.isArray(o.value[d])) {
						let e = o.value[d].map((e) => new $(e));
						Array.isArray(T.value) || (T.value = e.map((e) => e.getFile()));
						let t = await Promise.all(T.value.map((e) => $.fromFile(e)));
						e.find((e, n) => !e.equals(t[n])) && (T.value = e.map((e) => e.getFile()));
					}
				} else if (o.value[d]) {
					let e = new $(o.value[d]);
					T.value instanceof File || (T.value = e.getFile());
					let t = await $.fromFile(T.value);
					e.equals(t) || (T.value = e.getFile());
				}
				D();
			}, { immediate: !0 }), y(D), (t, i) => (x(), n(A(re), {
				id: A(f),
				modelValue: T.value,
				"onUpdate:modelValue": i[0] ||= (e) => T.value = e,
				state: E.value,
				class: h({
					vjf_file: !0,
					noBorderRadius: A(m)
				}),
				multiple: A(_),
				accept: A(S),
				required: e.required,
				"browse-text": A(p)?.getString("controls.upload.browse"),
				"drop-placeholder": A(p)?.getString("controls.upload.dropFilesHere"),
				placeholder: r.placeholder ?? A(p)?.getString("controls.upload.noFileChosen")
			}, null, 8, [
				"id",
				"modelValue",
				"state",
				"class",
				"multiple",
				"accept",
				"required",
				"browse-text",
				"drop-placeholder",
				"placeholder"
			]));
		}
	}), [["__scopeId", "data-v-017567ef"]]),
	NumberControl: Pn,
	ObjectControl: wr,
	RadiobuttonControl: ti,
	SelectControl: ni,
	StringControl: ri,
	TagsControl: Tr,
	FormFieldWrapper: ai,
	ErrorViewer: Dn,
	Button: ci,
	Buttongroup: jn,
	HelpPopover: Tn,
	DefaultControl: kn,
	ArrayButton: Fe,
	WizardProgress: Ge,
	Modal: /* @__PURE__ */ l({
		__name: "Modal",
		props: { layoutElement: {} },
		setup(n) {
			let r = n, a = C(!1), o = t(() => {
				switch (r.layoutElement.modal.size) {
					case "small": return "sm";
					case "large": return "lg";
					case "x-large": return "xl";
					default: return "md";
				}
			}), l = t(() => ({
				type: "HTML",
				htmlData: r.layoutElement.modal.content
			})), d = u($e);
			return (t, r) => (x(), i(e, null, [c(A(L), {
				variant: n.layoutElement.button.variant || "info",
				onClick: r[0] ||= (e) => a.value = !0
			}, {
				default: P(() => [s(D(n.layoutElement.button.text), 1)]),
				_: 1
			}, 8, ["variant"]), c(A(fe), {
				modelValue: a.value,
				"onUpdate:modelValue": r[2] ||= (e) => a.value = e,
				size: o.value,
				centered: "",
				scrollable: "",
				title: n.layoutElement.modal.title
			}, {
				footer: P(() => [c(A(L), {
					variant: "primary",
					class: "w-100",
					onClick: r[1] ||= (e) => a.value = !1
				}, {
					default: P(() => [s(D(A(d)?.getString("buttons.close") || "Close"), 1)]),
					_: 1
				})]),
				default: P(() => [c(In, { "layout-element": l.value }, null, 8, ["layout-element"])]),
				_: 1
			}, 8, [
				"modelValue",
				"size",
				"title"
			])], 64));
		}
	}),
	ConfirmationModal: /* @__PURE__ */ l({
		__name: "ConfirmationModal",
		props: {
			title: {},
			confirmButtonText: {},
			cancelButtonText: {},
			hideCancelButton: { type: Boolean },
			confirmButtonVariant: {},
			cancelButtonVariant: {}
		},
		emits: ["confirm", "cancel"],
		setup(e, { expose: t, emit: r }) {
			let i = e, a = r, o = ee("modal");
			return t({ show: () => {
				o.value?.show();
			} }), (e, t) => (x(), n(A(fe), {
				ref_key: "modal",
				ref: o,
				centered: "",
				title: i.title,
				"ok-title": i.confirmButtonText,
				"ok-variant": i.confirmButtonVariant,
				"cancel-title": i.cancelButtonText,
				"cancel-variant": i.cancelButtonVariant,
				"ok-only": i.hideCancelButton,
				onOk: t[0] ||= (e) => a("confirm"),
				onCancel: t[1] ||= (e) => a("cancel")
			}, {
				default: P(() => [T(e.$slots, "default")]),
				_: 3
			}, 8, [
				"title",
				"ok-title",
				"ok-variant",
				"cancel-title",
				"cancel-variant",
				"ok-only"
			]));
		}
	})
}, di = /* @__PURE__ */ l({
	__name: "ValidationError",
	props: { error: {} },
	setup(e) {
		let t = X().formStructureStore.getComponent("ErrorViewer");
		return (r, i) => (x(), n(E(A(t)), {
			header: e.error.title,
			class: "mb-3"
		}, {
			default: P(() => [
				a("p", null, [
					i[0] ||= s(" Error in element ", -1),
					a("code", null, D(e.error.path), 1),
					i[1] ||= s(": ", -1)
				]),
				a("p", null, D(e.error.message), 1),
				i[2] ||= a("hr", null, null, -1),
				a("pre", null, D(JSON.stringify(e.error.internalError, null, 2)), 1)
			]),
			_: 1
		}, 8, ["header"]));
	}
}), fi = /* @__PURE__ */ l({
	__name: "ParsingError",
	props: { error: {} },
	setup(e) {
		let t = X().formStructureStore.getComponent("ErrorViewer");
		return (r, i) => (x(), n(E(A(t)), {
			header: e.error.name,
			class: "mb-3"
		}, {
			default: P(() => [a("p", null, D(e.error.message), 1)]),
			_: 1
		}, 8, ["header"]));
	}
}), pi = { key: 0 }, mi = { key: 1 }, hi = { key: 2 }, gi = { key: 3 }, _i = {
	key: 4,
	class: "mt-4"
}, vi = { key: 5 }, yi = { key: 6 }, bi = /* @__PURE__ */ l({
	__name: "ParsingAndValidationErrorsView",
	props: { validationErrors: {} },
	setup(o) {
		let s = o, c = t(() => !!(s.validationErrors.jsonSchema.parsing.length + s.validationErrors.jsonSchema.validation.length)), l = t(() => !!(s.validationErrors.uiSchema.parsing.length + s.validationErrors.uiSchema.validation.length));
		return (t, s) => (x(), i(e, null, [
			s[5] ||= a("h4", null, "Error", -1),
			s[6] ||= a("p", null, "There were errors while rendering this form", -1),
			o.validationErrors.general.length ? (x(), i("div", pi, [s[0] ||= a("h5", null, "General", -1), (x(!0), i(e, null, w(o.validationErrors.general, (e) => (x(), n(fi, {
				key: e.message,
				error: e
			}, null, 8, ["error"]))), 128))])) : r("", !0),
			c.value ? (x(), i("h5", mi, "JSON Schema")) : r("", !0),
			o.validationErrors.jsonSchema.parsing.length > 0 ? (x(), i("div", hi, [s[1] ||= a("h6", null, "Parsing errors", -1), (x(!0), i(e, null, w(o.validationErrors.jsonSchema.parsing, (e) => (x(), n(fi, {
				key: e.message,
				error: e
			}, null, 8, ["error"]))), 128))])) : r("", !0),
			o.validationErrors.jsonSchema.validation.length > 0 ? (x(), i("div", gi, [s[2] ||= a("h6", null, "Validation errors", -1), (x(!0), i(e, null, w(o.validationErrors.jsonSchema.validation, (e) => (x(), n(di, {
				key: e.message + e.path,
				error: e
			}, null, 8, ["error"]))), 128))])) : r("", !0),
			l.value ? (x(), i("h5", _i, "UI Schema")) : r("", !0),
			o.validationErrors.uiSchema.parsing.length > 0 ? (x(), i("div", vi, [s[3] ||= a("h6", null, "Parsing errors", -1), (x(!0), i(e, null, w(o.validationErrors.uiSchema.parsing, (e) => (x(), n(fi, {
				key: e.message,
				error: e
			}, null, 8, ["error"]))), 128))])) : r("", !0),
			o.validationErrors.uiSchema.validation.length > 0 ? (x(), i("div", yi, [s[4] ||= a("h6", null, "Validation errors", -1), (x(!0), i(e, null, w(o.validationErrors.uiSchema.validation, (e) => (x(), n(di, {
				key: e.message + e.path,
				error: e
			}, null, 8, ["error"]))), 128))])) : r("", !0)
		], 64));
	}
}), xi = {
	errors: {
		fileUpload: {
			tooManyFiles: "Sie können nur !&data&! Dateien hochladen.",
			onlyOne: "Sie können nur eine Datei hochladen.",
			tooFewFiles: "Sie müssen mindestens !&data&! Dateien hochladen.",
			atLeastOne: "Sie müssen mindestens eine Datei hochladen.",
			fileTooLarge: "Die folgenden Dateien überschreiten die Dateigrößenbeschränkung von !&data&! MB: !&data&!"
		},
		checkboxGroup: {
			selectAtLeastOne: "Bitte wählen Sie mindestens eine Option aus.",
			selectAtMostOne: "Bitte wählen Sie höchstens eine Option aus.",
			selectAtLeast: "Bitte wählen Sie mindestens !&data&! Optionen aus.",
			selectAtMost: "Bitte wählen Sie höchstens !&data&! Optionen aus."
		},
		generic: {
			errorOccurred: "Ein Fehler ist aufgetreten:",
			retryLater: "Bitte versuchen Sie es später erneut.",
			temporaryError: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."
		}
	},
	buttons: {
		previous: "Zurück",
		next: "Weiter",
		close: "Schließen",
		save: "Speichern",
		clipboard: "In Zwischenablage kopieren",
		feedback: "Feedback"
	},
	controls: { upload: {
		browse: "Durchsuchen",
		noFileChosen: "Keine Datei ausgewählt",
		dropFilesHere: "Dateien hierher ziehen, um sie hochzuladen"
	} },
	modals: {
		"delete-remaining-items": {
			title: "Löschen der übrigen Elemente",
			text: "Da dieses Array mindestens !&data&! Elemente erfordert, werden alle übrigen Elemente aus dem Array gelöscht. Sind Sie sicher?",
			confirm: "Löschen",
			cancel: "Abbrechen"
		},
		summary: {
			title: "Zusammenfassung",
			saveTitle: "Titel",
			saveInstruction: "Setzen Sie einen Titel für die generierte Seite:"
		}
	}
}, Si = {
	errors: {
		fileUpload: {
			tooManyFiles: "You can only upload !&data&! files.",
			onlyOne: "You can only upload one file.",
			tooFewFiles: "You need to upload at least !&data&! files.",
			atLeastOne: "You need to upload at least one file.",
			fileTooLarge: "The following files exceed the file size limit of !&data&! MB: !&data&!"
		},
		checkboxGroup: {
			selectAtLeastOne: "Please select at least one option.",
			selectAtMostOne: "Please select at most one option.",
			selectAtLeast: "Please select at least !&data&! options.",
			selectAtMost: "Please select at most !&data&! options."
		},
		generic: {
			errorOccurred: "An error occurred:",
			retryLater: "Please try again later.",
			temporaryError: "An error occurred. Please try again later."
		}
	},
	buttons: {
		previous: "Previous",
		next: "Next",
		close: "Close",
		save: "Save",
		clipboard: "Copy to clipboard",
		feedback: "Feedback"
	},
	controls: { upload: {
		browse: "Browse",
		noFileChosen: "No file chosen",
		dropFilesHere: "Drop files here to upload"
	} },
	modals: {
		"delete-remaining-items": {
			title: "Delete the remaining items",
			text: "Since this array requires at least !&data&! items, this will delete all remaining items from the array. Are you sure?",
			confirm: "Delete",
			cancel: "Cancel"
		},
		summary: {
			title: "Summary",
			saveTitle: "Title",
			saveInstruction: "Choose a title for the generated page:"
		}
	}
}, Ci = class {
	getStringTemplate(e, ...t) {
		let n = this.getString(e);
		return (n.match(/!&data&!/g) || []).forEach((e, r) => {
			n = n.replace(/!&data&!/, t[r] || "");
		}), n;
	}
}, wi = class extends Ci {
	getString(e) {
		let t = this.data;
		for (let n of e.split(".")) if (t = t?.[n], t === void 0) return e;
		return typeof t == "string" ? t : e;
	}
}, Ti = class extends wi {
	data = xi;
}, Ei = class extends wi {
	data = Si;
}, Di = class extends Ci {
	provider;
	constructor() {
		super(), (navigator.language || "en").startsWith("de") ? this.provider = new Ti() : this.provider = new Ei();
	}
	getString(e) {
		return this.provider.getString(e);
	}
}, Oi = /* @__PURE__ */ l({
	__name: "WizardPage",
	props: {
		page: {},
		pageName: {},
		index: {}
	},
	setup(t) {
		let n = t, r = wn();
		function o() {
			let e = [...document.getElementById(r)?.querySelectorAll("*") || []].filter(on).map((e) => ({
				valid: e.checkValidity(),
				el: e
			}));
			return e.find((e) => !e.valid)?.el.reportValidity(), e.every((e) => e.valid);
		}
		let { formStructureStore: s } = X();
		return s.wizardValidateFunctions[n.index] = o, b(() => {
			delete s.wizardValidateFunctions[n.index];
		}), (n, o) => (x(), i(e, null, [a("h2", null, D(t.pageName), 1), c(vr, {
			id: A(r),
			"layout-element": t.page
		}, null, 8, ["id", "layout-element"])], 64));
	}
}), ki = { class: "pages-wrapper" }, Ai = /* @__PURE__ */ H(/* @__PURE__ */ l({
	__name: "Wizard",
	props: { wizardElement: {} },
	setup(n) {
		let { formStructureStore: r } = X(), o = r.getComponent("WizardProgress"), s = n, { currentWizardPage: l } = B(r), u = t(() => s.wizardElement.pages.map((e, t) => t === l.value));
		return (t, r) => (x(), i(e, null, [
			c(A(o), {
				"current-step": A(l),
				"onUpdate:currentStep": r[0] ||= (e) => d(l) ? l.value = e : null,
				"number-of-pages": n.wizardElement.pages.length,
				"page-names": n.wizardElement.options?.pageTitles
			}, null, 8, [
				"current-step",
				"number-of-pages",
				"page-names"
			]),
			r[1] ||= a("hr", null, null, -1),
			a("div", ki, [(x(!0), i(e, null, w(n.wizardElement.pages, (e, t) => (x(), i("div", { key: "wizard-page-" + t }, [F(a("div", null, [c(Oi, {
				page: e,
				"page-name": n.wizardElement.options?.pageTitles?.[t],
				index: t
			}, null, 8, [
				"page",
				"page-name",
				"index"
			])], 512), [[M, u.value[t]]])]))), 128))])
		], 64));
	}
}), [["__scopeId", "data-v-3d4da782"]]), ji = ["id"], Mi = /* @__PURE__ */ l({
	__name: "FormRoot",
	props: {
		onSubmitForm: { type: Function },
		jsonSchema: {},
		uiSchema: {},
		renderInterface: {},
		presetData: {},
		generationOptions: {},
		returnDataAsScopes: { type: Boolean },
		mappers: {},
		hideValidationState: { type: Boolean },
		validator: { type: Function },
		languageProvider: {},
		formId: {}
	},
	setup(e) {
		let a = e, o = a.formId ?? st();
		S(qe, o), ve(_e() || he()), S(Qe, {}), S($e, a.languageProvider || new Di());
		let { formStructureStore: s, formDataStore: c } = X(o), { jsonSchema: l, uiSchema: u, mappers: d, components: p, defaultData: m, buttonWaiting: g, formStateWasValidated: v } = B(s), { formData: y, defaultFormData: b, cleanedFormData: w } = B(c), E = C({
			general: [],
			jsonSchema: {
				validation: [],
				parsing: []
			},
			uiSchema: {
				validation: [],
				parsing: []
			}
		}), D = t(() => a.validator ? new a.validator() : new xe()), k = t(() => {
			let e = "vjf_form";
			return v.value && !a.hideValidationState && (e += " was-validated"), e;
		});
		async function j(e) {
			e.preventDefault(), e.stopPropagation();
			let t = e, n;
			n = a.returnDataAsScopes ? O(w.value.scopes) : O(w.value.json);
			let r = JSON.parse(decodeURIComponent(t.submitter?.attributes?.getNamedItem("submit-options")?.value || "false")) || {};
			g.value[r.id] = !0;
			try {
				await a.onSubmitForm(n, r, t);
			} catch (e) {
				console.error("Failed to submit form"), console.error(e);
			} finally {
				g.value[r.id] = !1;
			}
		}
		function ee() {
			b.value = {
				...ht(a.presetData || {}),
				...m.value
			};
		}
		function M() {
			y.value = { ...b.value };
		}
		function P(e) {
			e.preventDefault(), M(), v.value = !1;
		}
		async function F(e) {
			return D.value.validateJsonSchema(e) ? e : (E.value.jsonSchema.validation = D.value.getJsonSchemaValidationErrors(), null);
		}
		async function I(e, t) {
			return e ? D.value.validateUiSchema(e) ? ot(e) ? e : (E.value.uiSchema.validation = [{
				title: "Invalid UI Schema Version",
				path: "/version",
				message: `Invalid UI Schema version '${e.version}' is incompatible with this parser's supported version '2.2'`
			}], null) : (E.value.uiSchema.validation = D.value.getUiSchemaValidationErrors(), null) : ft(t, a.generationOptions);
		}
		function L(e) {
			p.value = e ? f(e) : void 0;
		}
		async function te(e) {
			e.renderInterface && L(e.renderInterface), d.value = a.mappers || [];
			let t = await F(e.jsonSchema).catch((e) => {
				E.value.jsonSchema.parsing.push(e), console.error(e);
			});
			if (!t) return;
			l.value = t;
			let n = await I(e.uiSchema, t).catch((e) => {
				E.value.uiSchema.parsing.push(e), console.error(e);
			});
			n && (u.value = n.layout);
		}
		S(Ye, !0);
		async function R() {
			try {
				await D.value.initialize();
			} catch (e) {
				console.error("Failed to initialize validator"), console.error(e), e instanceof Error && (E.value.general = [e]);
			}
		}
		async function z() {
			await R(), await te({
				jsonSchema: a.jsonSchema,
				uiSchema: a.uiSchema,
				renderInterface: a.renderInterface
			}), ee(), M();
		}
		return _(z), N([() => a.jsonSchema, () => a.uiSchema], z), N(D, R), N(() => a.renderInterface, (e) => {
			L(e);
		}), (e, t) => A(u) && A(l) ? (x(), i("form", {
			key: 0,
			id: A(o),
			class: h(k.value),
			onSubmit: j,
			onReset: P,
			onInvalidCapture: t[0] ||= (e) => v.value = !0
		}, [A(an)(A(u)) ? (x(), n(vr, {
			key: 0,
			"layout-element": A(u)
		}, null, 8, ["layout-element"])) : A(rn)(A(u)) ? (x(), n(Ai, {
			key: 1,
			"wizard-element": A(u)
		}, null, 8, ["wizard-element"])) : r("", !0), T(e.$slots, "default")], 42, ji)) : E.value.jsonSchema.parsing.length + E.value.jsonSchema.validation.length + E.value.uiSchema.parsing.length + E.value.uiSchema.validation.length + E.value.general.length > 0 ? (x(), n(bi, {
			key: 1,
			"validation-errors": E.value
		}, null, 8, ["validation-errors"])) : r("", !0);
	}
}), Ni = "0.0.0";
//#endregion
export { Di as AutoLanguageProvider, Nt as DependentRequiredMapper, Ei as EnglishLanguageProvider, Ti as GermanLanguageProvider, Et as IfThenElseMapper, wi as JSONLanguageProvider, Ci as LanguageProvider, xt as Mapper, Ct as MapperWithData, St as MapperWithoutData, Tt as OneOfToEnumMapper, $r as RenderHelpers, Mt as RitaDependentOptionsMapper, Mi as VueJsonForm, tn as allDefined, ui as bootstrapComponents, ft as generateUISchema, pt as getPropertyByString, Rt as hasCssClass, It as hasElements, Ht as hasEnumValuesForItems, Vt as hasItems, q as hasOption, K as hasProperty, en as isDefined, Ft as isDependentElement, sn as isElementWithCustomValidity, Lt as isEnumButtonsConfig, qt as isIfThenAllOf, Ut as isInputType, Wt as isInputTypeWithoutHidden, Pt as isKeyOf, an as isLayout, zt as isLegacyShowOn, Kt as isMapperWithData, Gt as isMapperWithoutData, nn as isNotNullOrUndefined, Zt as isSupportedIf, Jt as isSupportedIfCondition, $t as isSupportedIfThenElse, Qt as isSupportedThenOrElse, Bt as isValidJsonSchemaKey, on as isValidateableElement, rn as isWizard, at as supportedUiSchemaVersion, Or as validateCheckboxGroupInput, li as validateFileInput, Ni as version };

//# sourceMappingURL=vue-json-form.js.map